import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface NotificationMailUser {
  id: number
  userId: string
  name: string
  nameKana: string
  userStatus: SystemCode
  addressCode: string
  areaCode: string
  lendDate: string
  expirationDate: string
  mailAddress: string
  reserve: boolean
  newArrival: boolean
  remind: boolean
  notice: boolean
  event: boolean
}

export function NotificationMailUserFromJSON(json: any): NotificationMailUser {
  return {
    id: exists(json, 'id') ? json.id : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    userStatus: exists(json, 'user_status')
      ? SystemCodeFromJSON(json.user_status)
      : defaultSystemCode(),
    addressCode: exists(json, 'address_code') ? json.address_code : '',
    areaCode: exists(json, 'area_code') ? json.area_code : '',
    lendDate: exists(json, 'lend_date')
      ? dateToPlainFormat(json.lend_date)
      : '',
    expirationDate: exists(json, 'expiration_date')
      ? dateToPlainFormat(json.expiration_date)
      : '',
    mailAddress: exists(json, 'mail_address') ? json.mail_address : '',
    reserve: exists(json, 'reserve') ? json.reserve : false,
    newArrival: exists(json, 'new_arrival') ? json.new_arrival : false,
    remind: exists(json, 'remind') ? json.remind : false,
    notice: exists(json, 'notice') ? json.notice : false,
    event: exists(json, 'event') ? json.event : false
  }
}
